import { loadStripe } from '@stripe/stripe-js';

export const getStripeConfig = () => {
    // Use custom environment flag - will actually respect the value you set!
    const isProduction = process.env.REACT_APP_STRIPE_MODE === 'production';
    
    return {
      publicKey: isProduction 
        ? process.env.REACT_APP_STRIPE_PUBLIC_KEY
        : process.env.REACT_APP_STRIPE_PUBLIC_KEY_SANDBOX_TEST,

      secretKey: isProduction 
        ? process.env.STRIPE_SECRET_KEY 
        : process.env.STRIPE_SECRET_KEY_SANDBOX_TEST,
      webhookSecret: isProduction
        ? process.env.STRIPE_WEBHOOK_SIGNING_SECRET
        : process.env.STRIPE_WEBHOOK_SIGNING_SECRET_SANDBOX_TEST,
      priceIds: {
        monthly: isProduction
          ? process.env.STRIPE_PRICE_ID_MONTHLY
          : process.env.STRIPE_PRICE_ID_MONTHLY_SANDBOX_TEST,
        lifetime: isProduction
          ? process.env.STRIPE_PRICE_ID_LIFETIME_ACCESS_ONE_TIME_PAYMENT
          : process.env.STRIPE_PRICE_ID_LIFETIME_ACCESS_ONE_TIME_PAYMENT_SANDBOX_TEST,
      }
    };
  };

// Initialize Stripe outside component to avoid recreating it on re-renders
const config = getStripeConfig();
export const stripePromise = loadStripe(config.publicKey || 'stripe_public_key');

// Debug logging
console.log('🔍 STRIPE CONFIG DEBUG:');
console.log('  - REACT_APP_STRIPE_MODE:', process.env.REACT_APP_STRIPE_MODE);
console.log('  - Using production mode:', process.env.REACT_APP_STRIPE_MODE === 'production');
console.log('  - Public key starts with:', config.publicKey?.substring(0, 8));